package org.hs_soft.runmynesto.domain.usecase.options.restaurant_manager

import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.update_restaurant_project.UpdateRestaurantProjectModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.restaurant_manager.UpdateRestaurantProjectRepository


class UpdateRestaurantProjectUseCase(
    private val repository: UpdateRestaurantProjectRepository,
) {
    suspend operator fun invoke(
        caption:String,
        id:String,
    ): UpdateRestaurantProjectModel {
        return repository.updateProject(
            caption=caption,
            id =id,
        )
    }
}